module.exports = __webpack_public_path__ + "img/haus-salia.e59014cf.jpg";